export const navbar = state => {
  return state.navbar;
};

export const navbar_rerender = state => {
  return state.navbarReRender;
};

export const sectionHover = state => {
  return state.sectionHover
};

export const layoutStyle = state => {
  return state.layoutStyle;
};

export const openStyleFromSection = state => {
  return state.openStyleFromSection;
};

export const selectedPage = state => {
  return state.selectedPage;
};


